import styled, { css } from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";
import { KOGMediaQuery } from "@/main/services/utilsLayout";

export const Container = styled(ContainerSection)``;

export const BodySection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const RowContainer = styled.div`
	display: grid;
	grid-template-columns: 3fr repeat(2, 2fr) repeat(5, 1fr);
	gap: 0.4rem;

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.desktop,
			includeOrientation: false,
			styles: css`
				grid-template-columns: 2fr repeat(2, 1fr) repeat(4, 1fr) 1fr;
			`,
		})}

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.mobile,
			includeOrientation: false,
			styles: css`
				grid-template-columns: 1fr;
			`,
		})}
`;
